import { render, staticRenderFns } from "./AllocatedBackorderHistoryFilters.vue?vue&type=template&id=4fd92b8a&"
import script from "./AllocatedBackorderHistoryFilters.vue?vue&type=script&lang=js&"
export * from "./AllocatedBackorderHistoryFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports